import { NsKey } from 'enums/NsKey';
import { InputFactory } from 'factories/InputFactory';
import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { useCallback } from 'react';
import { minimalNaturalPersonInputsConfig } from './minimalBorrowerForm.inputs';
import { MinimalBorrowerFormFieldNames } from './minimalBorrowerForm';

// Visible field names for natural person form
type MinimalNaturalPersonVisibleFields =
  | PersonalInformationFieldNames.Civility
  | PersonalInformationFieldNames.LastName
  | PersonalInformationFieldNames.FirstName
  | PersonalInformationFieldNames.Email
  | PersonalInformationFieldNames.BirthDate
  | typeof MinimalBorrowerFormFieldNames.AddressSearch
  | typeof MinimalBorrowerFormFieldNames.AdditionalAddress
  | typeof MinimalBorrowerFormFieldNames.ExistingOutstanding;

export const MinimalNaturalPersonLayout: React.FC = () => {
  const { t } = useDynamicTranslation([NsKey.Borrower, NsKey.ActorForm]);

  const renderField = useCallback((fieldName: MinimalNaturalPersonVisibleFields) => {
    return (
      <InputFactory<MinimalNaturalPersonVisibleFields>
        config={minimalNaturalPersonInputsConfig}
        fieldName={fieldName}
      />
    );
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-6 gap-4">
        <div className="col-span-2">
          {renderField(PersonalInformationFieldNames.Civility)}
        </div>
        <div className="col-span-4">
          {renderField(PersonalInformationFieldNames.LastName)}
        </div>
        <div className="col-span-3">
          {renderField(PersonalInformationFieldNames.FirstName)}
        </div>
        <div className="col-span-3">
          {renderField(PersonalInformationFieldNames.Email)}
        </div>
        <div className="col-span-3">
          {renderField(PersonalInformationFieldNames.BirthDate)}
        </div>
        <div className="col-span-6">
          {renderField(MinimalBorrowerFormFieldNames.AddressSearch)}
        </div>
        <div className="col-span-6">
          {renderField(MinimalBorrowerFormFieldNames.AdditionalAddress)}
        </div>
        <div className="col-span-6">
          {renderField(MinimalBorrowerFormFieldNames.ExistingOutstanding)}
        </div>
      </div>
    </div>
  );
};
